import React from 'react';
import { Button, Typography } from '@mui/material';

//import {  } from '@mui/icons-material';
import { noop } from '@cd/utils';
import { usePresence, motion } from 'framer-motion';
import { column, row } from './commonCSS';

const buttonAnim = {
	open: {
		opacity: 1,
		scale: 1,
		transition: {
			duration: 0.4,
			type: 'spring',
			stiffness: 400,
			mass: 2,
			damping: 20
		}
	},
	close: {
		opacity: 0,
		scale: 0,
		transition: {
			duration: 0.4,
			type: 'spring',
			stiffness: 400,
			mass: 2,
			damping: 20
		}
	}
};

const parenVariant = {
	open: {
		transition: {
			staggerChildren: 0.2,
			staggerDirection: 1,
			duration: 0.4
		}
	},
	close: {
		transition: {
			delayChildren: 0,
			staggerChildren: 0.2,
			staggerDirection: -1,
			duration: 0.4
		}
	}
};
const mainVariant = {
	open: {
		opacity: 1,
		transition: {
			staggerChildren: 0.2,
			staggerDirection: 1,
			duration: 0.4,
			delay: 0.4
		}
	},
	close: {
		opacity: 0,
		transition: {
			delayChildren: 0,
			staggerChildren: 0.2,
			staggerDirection: -1,
			duration: 0.4
		}
	}
};
const ConfirmButtonGroupCD = ({
	isOpen = false,
	okLabel = 'OK',
	cancelLabel = 'CANCEL',
	message,
	onCancel = noop,
	onOk = noop
}) => {
	const [isPresent, safeToRemove] = usePresence();
	return (
		<motion.div
			key="letterParent"
			initial="close"
			animate={isPresent ? 'open' : 'close'}
			onAnimationComplete={def => def === 'close' && safeToRemove()}
			variants={mainVariant}
			css={column}>
			<Typography component="div">{message}</Typography>

			<motion.div
				css={row}
				sx={{ display: 'flex', gap: '4px' }}
				variants={parenVariant}>
				<motion.div variants={buttonAnim}>
					<Button
						key={okLabel}
						small
						onClick={e => onOk()}
						variant="outlined">
						{okLabel}
					</Button>
				</motion.div>
				<motion.div variants={buttonAnim}>
					<Button
						key={cancelLabel}
						small
						onClick={e => onCancel()}
						variant="outlined">
						{cancelLabel}
					</Button>
				</motion.div>
			</motion.div>
		</motion.div>
	);
};
export default ConfirmButtonGroupCD;
